import React, { useState, useEffect } from "react";
import { Button, Col, Image, Modal, Row } from "react-bootstrap";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import CustomisationEditModel from "../../../../vendorDashboardComponents/Orders/OrderRequest/CustomisationEditModel";
import { get_category_menu_setup } from "../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";
import { ITEMTYPEVEG } from "../../../../../enums/OrderEnums";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const AddItem = (props) => {
  let view = false;

  if (
    props.orderDetails?.order_type === 2 ||
    props.orderDetails?.order_type === 3
  ) {
    if (
      props.orderDetails?.order_status !== 7 ||
      props.orderDetails?.order_status !== 8
    ) {
      view = true;
    }
  } else {
    if (
      props.orderDetails?.order_status === 0 ||
      props.orderDetails?.order_status === 1
    ) {
      view = true;
    }
  }

  // console.log(
  //   (props.orderDetails?.order_type === 2 ||
  //     props.orderDetails?.order_type === 3) &&
  //     (props.orderDetails?.order_status !== 6 ||
  //       props.orderDetails?.order_status !== 7 ||
  //       props.orderDetails?.order_status !== 8),
  //   "conditions"
  // );
  return (
    <React.Fragment key={props.index}>
      <div className="row pb-4">
        <div
          style={{ alignItems: "center" }}
          className="col-6 col-sm-6 col-md-3 align-middle d-flex"
        >
          <div>
            <SimpleReactLightbox>
              <SRLWrapper options={options}>
                <Image
                  src={
                    (props.item.item.images && props.item.item.images[0]) ||
                    NOTAVAILABLEIMAGE
                  }
                  alt="Item Image"
                  title={props.item.item.name}
                  style={{
                    borderRadius: "3px",
                    height: "43px",
                    width: "43px",
                  }}
                />
              </SRLWrapper>
            </SimpleReactLightbox>
          </div>
          <div className="px-2">
            {/* {console.log("props?.item?.item", props?.item?.item)}
            {ITEMTYPEVEG.map((type, index) => {
              return (
                <React.Fragment key={index}>
                  {props?.item?.item?.itemType === type?.value ? (
                    <Image
                      width="12px"
                      height="12px"
                      src={type.url}
                      alt={type.title}
                      title={type.title}
                      fluid
                    />
                  ) : null}
                </React.Fragment>
              );
            })} */}
            <Image
              src={
                props.item && props.item.item && props.item.item.veg
                  ? require("../../../../../assets/images/superadmin/ordericon/veg.svg")
                  : require("../../../../../assets/images/superadmin/ordericon/non veg.svg")
              }
              alt={
                props.item && props.item.item && props.item.item.veg
                  ? "veg"
                  : "non veg"
              }
              title={
                props.item && props.item.item && props.item.item.veg
                  ? "veg"
                  : "non veg"
              }
              width="20px"
              fluid
            />
          </div>
          <div className="px-2">{props.item?.item?.name}</div>
        </div>
        {/* <td
            style={{ width: "5%", paddingRight: "3px" }}
            className="align-middle"
          >
            
          </td>
          <td style={{ width: "30%" }} className="f14-500 align-middle">
           
          </td> */}
        {view ? (
          <>
            <div className="col-6 col-sm-6 col-md-3 align-middle text-center">
              <div className="d-flex align-items-center justify-content-center">
                <img
                  src={require("../../../../../assets/images/superadmin/ordericon/less.svg")}
                  width="30px"
                  alt="Less"
                  className="ml-2"
                  onClick={props.onClickMinusQty}
                />
                <h5 className="f12-700 mx-3">{props.item.quantity}</h5>
                <img
                  src={require("../../../../../assets/images/superadmin/ordericon/add.svg")}
                  width="30px"
                  alt="Add"
                  className="mr-2"
                  onClick={props.onClickAddQty}
                />
              </div>
            </div>
          </>
        ) : null}
        <div className="col-6 col-sm-6 col-md-3 f16-700 align-middle text-center">
          <i
            className="fa fa-inr"
            style={{ color: "#F85032" }}
            aria-hidden="true"
          ></i>{" "}
          {props?.item?.finalPrice !== undefined &&
          props?.item?.finalPrice !== null &&
          props?.item?.finalPrice !== "NaN" &&
          props?.item?.finalPrice !== ""
            ? props?.item?.finalPrice
            : props?.item?.size?.price * props?.item?.quantity}
        </div>
        {view ? (
          <>
            <div
              style={{
                textAlign: "right",
                paddingRight: "11px",
              }}
              className="col-6 col-sm-6 col-md-3 f12-700 align-middle"
            >
              {/* <div
              style={{ color: "#2196F3", paddingRight: "10%" }}
              className="f12-500"
              // onClick={() => {
              //   setOpen(true);
              // }}
            >
              Edit
            </div> */}
              {
                // props.dataLoader ? (
                //   <>Loading... </>
                // ) : (
                props.vendor_filtered_menu.map((data) => (
                  <>
                    {data?._id === props?.item?.item?.category ? (
                      <>
                        {data?.items.map((data1, index) => (
                          <>
                            {data1?._id === props?.item?.item?.id ? (
                              <>
                                <CustomisationEditModel
                                  customizationData={data1}
                                  orderSelected={props.orderSelected}
                                  categoryName={data.name}
                                  edit="edit"
                                  item={props.item}
                                />
                              </>
                            ) : null}
                          </>
                        ))}
                      </>
                    ) : null}
                  </>
                ))
                // )
              }
            </div>
          </>
        ) : null}
      </div>
      {/* <tr className="mt-2">
          <td></td> 
        </tr> */}
    </React.Fragment>
  );
};

// AddItem.propTypes = {
//     auth: PropTypes.object.isRequired,
//     errors: PropTypes.object.isRequired,
//   };

//   const mapStateToProps = (state) => ({
//     auth: state.auth,
//     errors: state.errors.errors,
//     menuCategory: state.onboarding.menuCategory,
//   });

// export default connect(mapStateToProps, {
//     get_category_menu_setup,
//   })(AddItem);
export default AddItem;
